import * as React from 'react';
import { Dispatch } from 'redux';
import { ShopViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ShopNormalizers from '../normalizers/shopNormalizers';

export class GetAllShopsRequest extends BaseApiGetRequest<
  ShopViewModel,
  EntityNormalizers.NormalizedEntityArray<ShopNormalizers.NormalizedShops>
> {
  constructor(component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/shops`;
    this.normalizeMethod = ShopNormalizers.normalizeShopsArray;
  }
}
